<template>
    <div>
        <div class="qMsgMarkBox">
            <div class="title">快捷消息类别管理</div>
            <div style="margin-top: 10px;">
                <div class="editBox" v-for="(v, i) in dataList" :key="i">
                    <template v-if="!v.state">
                        <input class="lmyLeft" type="text" readonly v-model="v.typeName">
                        <div><i class="el-icon-edit" @click="edtiFun(v, i)"></i><i class="el-icon-delete ml10"
                                @click="delFun(v, i)"></i></div>
                    </template>
                    <template v-else>
                        <input class="lmyLeft" type="text" v-model="editVal">
                        <div><i class="el-icon-check" @click="editSuccessFun()"></i><i class="el-icon-close ml10"
                                @click="cancelFun()"></i></div>
                    </template>
                </div>

                <div class="editBox" v-if="isAdd">
                    <input class="lmyLeft" type="text" v-model="editVal">
                    <div><i class="el-icon-check" @click="createFun()"></i><i class="el-icon-close ml10" @click="isAdd = false"></i></div>
                </div>
                <div class="addBox" v-else><el-button type="primary" icon="el-icon-circle-plus-outline"
                        @click="addFun">添加</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {quickMessageTypeList,addQuickMessageType,editQuickMessageType,quickMessageList,delQuickMessageType} from '@/api/attachment'
export default {
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        chatUserInfo:{
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            activeQMsgName: 'qmsg1',
            dataList: [],
            editVal: '',
            isAdd: false,
            checkData:''
        };
    },
    watch: {
        isShow: {
            handler(newVal) {
                console.log(newVal)
                if (newVal) {
                    this.getQuickMessageType()
                }
            },
            immediate: true  // 立即以当前值触发回调
        }
    },
    methods: {
        async getQuickMessageType(){
            console.log(123123,this.chatUserInfo)
            let res = await quickMessageTypeList({
                recId: this.chatUserInfo.recId,
                platformType: this.chatUserInfo.platformType,
                platformUserId: this.chatUserInfo.platformUserId,
            })
            if(res.code == 200){
                this.dataList = []
               let data = res.rows
               console.log(data)
               if(data.length > 0){
                this.dataList = data.map(item => {
                    return {
                        ...item,
                        state: false // 默认值设为false
                    };
                })
               }
            }
        },
        addFun() {
            this.isAdd = true;
            this.cancelFun();
        },
        createFun(){
            console.log(this.editVal);
            if(!this.editVal){
                this.$message.success('请填写上传类型');
                return
            }
            addQuickMessageType({
                platformType: this.chatUserInfo.platformType,
                platformUserId: this.chatUserInfo.platformUserId,
                typeName:this.editVal
            }).then(res=>{
                if(res.code == 200){
                    this.$message.success('上传成功');
                    this.isAdd = false
                    this.$emit('getQuickMessageType')
                    this.$emit('qMsgCreateClose')
                }
            })
        },
        delFun(v, i) {
            console.log(v, i)
            // 先获取其类型下是否有数据，如果有提示删除后再进行删除该组别
            quickMessageList({
                platformType: this.chatUserInfo.platformType,
                platformUserId: this.chatUserInfo.platformUserId,
                typeId:v.recId
            }).then(res=>{
                if(res.code == 200){
                    if(res.rows.length > 0){
                        this.$message.error('删除失败，请先删除该分类下所有文件后，再次尝试');
                    }else{
                        console.log(v.recId)
                        this.delSucccessFun(v.recId)
                    }
                }else{
                    this.$message.error(res.msg)
                }
            })
        },
        delSucccessFun(v){
            delQuickMessageType(v).then(res=>{
                if(res.code == 200){
                    this.$message.success('删除成功');
                    this.getQuickMessageType()
                    this.$emit('getQuickMessageType')
                    this.$emit('qMsgCreateClose')
                }else{
                    this.$message.error(res.msg)
                }
            })
        },
        // 提交编辑
        editSuccessFun() {
            if(!this.editVal){
                this.$message.error('请填写上传类型');
                return
            }
            if(!this.checkData.recId){
                this.$message.error('未获取到上传类型标识');
                return
            }
            editQuickMessageType({
                recId: this.checkData.recId,
                platformType: this.chatUserInfo.platformType,
                platformUserId: this.chatUserInfo.platformUserId,
                typeName:this.editVal
            }).then(res=>{
                if(res.code == 200){
                    this.$message.success('修改成功');
                    this.$emit('getQuickMessageType')
                    this.$emit('qMsgCreateClose')
                }else{
                    this.$message.error(res.msg);
                }
            })
        },
        // 编辑快捷消息
        edtiFun(v, i) {
            this.editVal = v.typeName
            this.checkData = v
            this.dataList = this.dataList.map((item, index) => {
                // 当前点击项设为true，其他所有项设为false
                return {
                    ...item,
                    state: i === index
                };
            });
        },
        cancelFun() {
            this.dataList = this.dataList.map((item, index) => {
                // 当前点击项设为true，其他所有项设为false
                return {
                    ...item,
                    state: false
                };
            });
            console.log(this.dataList)
        },
        qMsgClick(tab) {
            console.log(tab.index);
        },
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.qMsgMarkBox {
    .title {
        font-size: 20px;
        font-weight: 600;
        text-align: center;
    }

    .editBox {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        border-bottom: 1px solid #eeeeee;

        .lmyLeft {
            width: 700px;
            // border-right: 1px solid #000;
            height: 100%;
            border: none;
            background-color: transparent;
            outline: none;
        }

        .ml10 {
            margin-left: 10px;
        }
    }

    .addBox {
        width: 100%;
        margin-top: 10px;
        display: flex;
        justify-content: center;
    }
}
</style>